/**
 * Injects or updates a page-level JSON-LD <script> tag in <head>.
 * Call the returned cleanup function (e.g. in useEffect return) to remove on unmount.
 */
export function setPageJsonLd(schema: Record<string, unknown>): void {
  const id = 'page-json-ld';
  let script = document.getElementById(id) as HTMLScriptElement | null;

  if (script) {
    script.textContent = JSON.stringify(schema);
  } else {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }
}

export function removePageJsonLd(): void {
  const el = document.getElementById('page-json-ld');
  if (el) el.remove();
}
